export default "__VITE_ASSET__DWqMOA8m__"